import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface HomeContainerProps {
  children: React.ReactNode;
  className?: string;
}

const ContainerComponent: React.FC<HomeContainerProps> = ({
  children,
  className,
}) => {
  return <div className={className}>{children}</div>;
};

export const Container: React.FC<HomeContainerProps> = (
  props: HomeContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'HomeContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};
